import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import { useCart } from "../components/contexts/CartContext";
import { useGeneral } from "../components/contexts/GeneralContext";
import axios from "../config/axios";
import { useToast } from "../components/contexts/ToastContext";
import GeneralButton from "../components/common/GeneralButton";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import { useStep } from "../components/contexts/SubscriptionContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";

const ProcessPaymentPage = () => {
  const { type, transactionId } = useParams();
  const { cart, fetchCart } = useCart();
  const { discountCoupons } = useGeneral();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [orderConfirmed, setOrderConfirmed] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [marketingData, setMarketingData] = useState(null);
  const location = useLocation();
  let mealCartId = localStorage.getItem("mealCartId");
  const { goToStep } = useStep();
  const params = new URLSearchParams(location.search);
  const renew = params.get("renew");
  useEffect(() => {
    goToStep("5");
  }, []);
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");
    if (type === "order") {
      checkPaymentAndPlaceOrder(sessionId);
    } else {
      checkPaymentAndPlaceMealSubscription(sessionId);
    }
  }, []);

  useEffect(() => {
    console.log("Order Confirmed useEffect called")
    if (typeof window !== "undefined" && window.fbq && orderConfirmed) {
      console.log("fbq called")
      window.fbq('track', 'Purchase', {
        value: marketingData.amount,
        currency: 'AED',
        content_type: 'product',
        eventID: marketingData.id
      });
    }
  }, [orderConfirmed]);


  // ✅ Validate & Place Regular Order
  const checkPaymentAndPlaceOrder = async (sessionId) => {
    try {
      setLoading(true);
      setStatus(null);
      const orderRes = await axios.post("/cart/place-order", {
        stripeSessionId: sessionId,
      });

      if (orderRes?.data?.orderId) {
        setOrderId(orderRes.data.orderId);
        
        setOrderConfirmed(true);
        setStatus("success");
        addToast("Order placed successfully!", "success");
        localStorage.removeItem("guestUserDetails");
        localStorage.removeItem("expressCheckoutAddress");
        localStorage.removeItem("savedCardInputData");
        //fetchCart();
        navigate(`/payment-received/order/success/${orderRes.data.orderId}`);
      } else {
        setStatus("failed");
        addToast(
          orderRes?.data?.message || "Order confirmation failed.",
          "error"
        );
        navigate(`/payment-received/order/failed/null`);
      }
    } catch (error) {
      addToast(
        error.response?.data?.message || "Order confirmation failed.",
        "error"
      );
      navigate(`/payment-received/order/failed/null`);
    } finally {
      setLoading(false);
    }
  };

  const checkPaymentAndPlaceMealSubscription = async (sessionId) => {
    try {
      setLoading(true);
      setStatus(null);

      setStatus("success");

      const orderRes = await axios.post("/cart/place-meal-subscription", {
        stripeSessionId: sessionId,
      });

      if (orderRes?.status === 200 || orderRes?.status === 201) {


        console.log(orderRes?.data)

        if(orderRes?.data?.marketingData){
          setMarketingData(orderRes.data.marketingData)
        }

        


        setOrderConfirmed(true);
        addToast("Meal Subscription successfully activated!", "success");
        //fetchCart();
        if (renew === "true") {
          navigate(`/payment-received/meals/success/1?renew=true`);
        } else {
          navigate(`/payment-received/meals/success/1`);
        }
        setTimeout(() => {
          navigate("/account", { replace: true });
        }, 10000);
      } else {
        setStatus("failed");
        addToast("Meal Subscription confirmation failed.", "error");

        navigate(`/payment-received/meals/failed/null`);
      }
    } catch (error) {
      addToast(
        error.response?.data?.message ||
          "Meal Subscription confirmation failed.",
        "error"
      );
      if (renew === "true") {
        navigate(`/payment-received/meals/failed/null`);
      } else {
        navigate(`/payment-received/meals/failed/null`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper loading={loading}>
      <Header code={discountCoupons} />
      {/* {loading && <FullScreenLoading />} */}
      <BodyWrapper className="mb-4">
        {type === "meals" && renew != "true" && (
          <TopStepsStatus url={""} rightText="" />
        )}
        {!orderConfirmed && !orderId && (
          <p className="text-28pt md:text-34pt pb-4 md:pb-6 2.5xl:pb-9 ">
            Processing Payment
          </p>
        )}

        <div className="grid grid-cols-1 2.5xl:grid-cols-1">
          <div className="flex flex-col items-center justify-center p-10 bg-[#DEE2DD]/40 rounded-[15px] gap-0">
            <div className="flex flex-col items-center gap-4 w-full">
              {/* Animated Credit Card */}
              <motion.div
                className="w-52 h-28 bg-gradient-to-r from-blue-600 to-blue-400 rounded-xl shadow-lg relative overflow-hidden p-4 flex flex-col justify-between"
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ type: "spring", stiffness: 120, damping: 12 }}
              >
                <motion.div
                  className="absolute top-0 left-0 h-full w-24 bg-white opacity-20 transform -rotate-12"
                  animate={{ x: ["-100%", "200%"] }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                />
                <p className="text-white text-sm tracking-widest font-mono">
                  **** **** **** ****
                </p>
                <div className="flex justify-between items-end text-white text-xs font-mono">
                  <span>***** ****</span>
                  <span>**/**</span>
                </div>
              </motion.div>

              {/* Processing Notice */}
              <div className="w-[95%] lg:w-[50%] p-4 flex flex-col items-center gap-4 rounded-xl">
                <p className="text-20pt text-center">
                  Your payment is being processed. Please do not refresh the
                  page or navigate away. This may take a few moments.
                </p>
                <div className="w-full bg-gray h-2 rounded-full overflow-hidden">
                  <motion.div
                    className="h-3 bg-green"
                    initial={{ width: 0 }}
                    animate={{ width: "100%" }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      repeatType: "loop",
                      ease: "linear",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* <div className="flex items-center justify-center gap-10 mt-4">
              <GeneralButton
                text="Success"
                bgColor="#A0AE3F"
                textColor="#fff"
                className="text-21pt"
                title="Click here for success result"
                onClick={
                  type === "order"
                    ? () => validatePayment(cart?.orderCart._id, transactionId)
                    : () => validatePaymentForMeal(mealCartId, transactionId)
                }
              />
              <GeneralButton
                text="Failure"
                bgColor="#D06F36"
                textColor="#fff"
                className="text-21pt"
                title="Click here for failure"
                onClick={
                  type === "order"
                    ? () => validatePayment(cart?._id, "fake-id")
                    : () => validatePaymentForMeal(mealCartId, "fake-id")
                }
              />
            </div> */}
          </div>
        </div>
      </BodyWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default ProcessPaymentPage;
